// extracted by mini-css-extract-plugin
export default {"container":"NestedListViewHeader-module__container__WSXhdTQ"};